import { useRef, useEffect } from "react";
import { useCookie } from "utils/cookieHelper";
import { MotionBox as Box } from "utils/motion";
import { useOnScreen } from "utils/hooks";
import ScheduleSection from "components/sections/ScheduleSection";
import SubscribeSection from "components/sections/SubscribeSection";
import FooterLinkMap from "components/sections/FooterLinkMap";

const Footer = ({
  updateVisible,
  small,
  noNewsletter,
  mandatoryFooter,
  ...props
}) => {
  const formRef = useRef();
  const showFooter = useOnScreen(formRef);
  const cookie = useCookie(props.cookie);

  useEffect(() => {
    if (updateVisible) {
      updateVisible(showFooter);
    }
  }, [showFooter, updateVisible]);

  return (
    <Box ref={formRef} bg="black.900">
      {!small && (
        <>
          <ScheduleSection cookie={cookie} idRef="register" {...props} />
          {!noNewsletter && <SubscribeSection model={props.model} />}
        </>
      )}
      <FooterLinkMap small={small} />
    </Box>
  );
};

export default Footer;
